import { Component, computed, HostBinding, input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { AvatarComponent } from '../avatar.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';

export interface AvatarGroupItem {
  src?: string;
  name?: string;
  onClick?(): void;
}

@Component({
  selector: 'glxy-avatar-group',
  templateUrl: './avatar-group.component.html',
  styleUrls: ['./avatar-group.component.scss'],
  imports: [AvatarComponent, MatTooltipModule, MatMenuModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class AvatarGroupComponent {
  @HostBinding('class') class = 'glxy-avatar-group';

  avatarList = input.required<AvatarGroupItem[]>();
  limit = input(3);
  avatarWidth = input(36);

  hasExtraAvatars = computed(() => this.avatarList().length > this.limit());

  shownAvatars = computed(() => this.avatarList().slice(0, this.limit()));
  extraAvatars = computed(() => this.avatarList().slice(this.limit(), this.avatarList().length));
}
